// extracted by mini-css-extract-plugin
module.exports = {"Overview":"CoursesOverview_Overview__1QIxN","Checkbox":"CoursesOverview_Checkbox__1nstz","Categories":"CoursesOverview_Categories__2UlQ8"};